import { render, staticRenderFns } from "./ImportantFeedbackContainer.vue?vue&type=template&id=35627fa9&"
import script from "./ImportantFeedbackContainer.vue?vue&type=script&lang=js&"
export * from "./ImportantFeedbackContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports